// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2bw3N","head":"Table_head__2sPH-","col":"Table_col__2uist"};